import { Component, Inject } from '@angular/core';
import { REFRESH_CREDENTIAL_ERROR$ } from './core/core.module';
import { Observable } from 'rxjs';
import { NavigationService } from './features/shared/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from './features/shared/services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { ChatwootService } from './features/shared/services/chatwoot.service';
import { AnalyticsService } from './features/shared/services/analytics.service';
import { DiagnosticsService } from './features/diagnostics/services/diagnostics.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { getAllServiceProviders, getStorageIcon } from '@uploadcam/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  /** Guards against stacking multiple session-expired dialogs when several requests fail at once. */
  private isHandlingSessionExpiry = false;

  constructor(
    analytics: AnalyticsService,
    chatwoot: ChatwootService,
    diagnostics: DiagnosticsService,
    dialog: DialogService,
    matDialog: MatDialog,
    navigation: NavigationService,
    @Inject(REFRESH_CREDENTIAL_ERROR$)
    refreshCredentialError$: Observable<void>,
    translate: TranslateService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    analytics.init();
    chatwoot.init();
    diagnostics.init();

    // When we can't refresh the credential, prompt the user to log in again. The "Log in again"
    // button takes them to our main login screen (with all provider options), instead of e.g.
    // Zoho's bare re-auth popup.
    refreshCredentialError$.subscribe(async () => {
      if (this.isHandlingSessionExpiry) {
        return;
      }
      this.isHandlingSessionExpiry = true;

      try {
        matDialog.closeAll();
        await dialog.sessionExpired();
        await navigation.logout();
      } finally {
        this.isHandlingSessionExpiry = false;
      }
    });

    // Set the default language
    translate.setDefaultLang('en');
    translate.use('en');

    // Register storage provider SVG icons
    getAllServiceProviders().forEach((provider) => {
      iconRegistry.addSvgIconInNamespace(
        'app',
        provider,
        sanitizer.bypassSecurityTrustResourceUrl(getStorageIcon(provider)),
      );
    });
  }
}
